<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre13"><span id="Seite_41" title="[S. 41]"></span></p>
<div class="figcenter4" id="p041_ill">
<img alt="" class="w" id="id-3423701691467903964" src="Images/img0013.jpg"/>
<div class="caption1">Meine Fähre am Ufer der Silman-Araber.</div>
</div>
<h2 class="nopad" id="Fuenftes_Kapitel"><span class="s11">Fünftes Kapitel.</span><br class="calibre10"/>
<b class="calibre14">Auf den Wellen des Euphrat.</b></h2>
</div>
<p class="calibre13"><span>E</span>s war ½6 Uhr nachmittags, als ich mich von meinen deutschen Freunden
in Dscherablus, von Rittmeister von Abel, der dienstlich dorthin
gekommen war, von Major von Schrenk und seinen Offizieren, und von Nuri
Bei verabschiedete.</p>
<p class="calibre13">„Jallah! Bismillah rahman errahim!“</p>
<p class="calibre13">Auf dieses Kommando stieß meine Fähre vom Ufer ab, wurde sogleich vom
Strom erfaßt, und bald waren Dscherablus und die deutsche Marinestation
außer Sehweite. Ich war, wie so oft auf meinen Entdeckungsfahrten,
allein mit meiner Arbeit unter wenigen eingeborenen Begleitern.</p>
<p class="calibre13">Unaufhaltsam trägt die starke Strömung meine Fähre gen Süden. Die
schmale Vorderwand meiner Hütte ist als Sonnendach hochgeklappt;
Kartenblatt, Kompaß und Uhr vor mir, sitze ich an meinem Schreibtisch
und zeichne unsere Fahrtrichtung und die Formen der Ufer ein. Die
steilen Bergfronten, die Klippen und Sandbänke, die grasbewachsenen<span id="Seite_42" title="[S. 42]"></span>
Inseln, die Wiesen, Dörfer und Zelte, Lehmhäuser und Hügel, die
Ergebnisse der Tiefen- und Geschwindigkeitsmessungen, sogar die
weidenden Herden, alles wird in die Karte eingetragen. Selten ist die
Richtung fünf Minuten lang die gleiche; gewöhnlich muß ich nach zwei,
drei Minuten neue Peilungen machen, und ich habe kaum Zeit, zwischen
den einzelnen Beobachtungen eine Zigarette anzubrennen. Ein Fernrohr
ermöglicht mir, das Leben der Nomaden an den Ufern zu beobachten und
die Eigentümlichkeit des beständig wechselnden Landschaftsbildes
genauer zu studieren. Kleine Entenscharen flattern dicht über der
Oberfläche des Flusses vor uns her. In der Ferne schreit der Kuckuck,
und von den Ufern her klingen die Glocken der Schafherden. Wenn es
ganz ruhig ist, hört man an der Oberfläche des Wassers ein Brodeln und
Zischen, wie wenn Wasser eben zu kochen beginnt. Dieser Laut begleitete
mich mehrere Tage und verschwand erst, als Luft und Wasser wärmer
geworden waren. Tag und Nacht bin ich auf dem Flusse; ich bin eins mit
ihm, lebe sein Leben und fühle, wie er arbeitet und sich rührt, um weit
im Süden bis zur Küste vorzudringen und im Meere seine Freiheit zu
gewinnen.</p>
<p class="calibre13">Das Land ringsum ist eine ungeheure Miozänkalksteinplatte, die bis
unterhalb Hit am Euphrat und bis Samarra am Tigris reicht und nicht
nur Nordsyrien bedeckt, sondern auch el-Dschesire, die Insel, oder
das Land zwischen den beiden Brüderströmen, das ungefähr dem alten
Assyrien entspricht. Ihre Höhe beträgt bis 500 Meter, so daß man von
einer Hochebene sprechen kann. Wo im Süden die tertiäre Kalksteinschale
aufhört, beginnt reines Schwemmland, dessen alluviale Ablagerungen
eine bedeutende Tiefe erreichen. Vermehrt durch den Schlamm, den beide
Ströme mit sich führen, schieben sich diese Ablagerungen immer weiter
in den Persischen Meerbusen vor. 2000 Jahre vor unserer Zeitrechnung
lag die chaldäische Stadt Suripak an der Küste, jetzt sind ihre
Ruinen 210 Kilometer von ihr entfernt! Noch zur Zeit Sardanapals
mündeten Euphrat und Tigris jeder für sich in den Persischen Golf.
Der Schatt-el-Arab, zu dem sich beide jetzt vereinen, ist also einer
der jüngsten Ströme der Welt. Dies Alluvialland entspricht dem alten
Babylonien, dem Irak-Arabi der Gegenwart. In seinem subtropischen Klima
gedeihen Zuckerrohr, Reis und Datteln, und in naher Zukunft sollen hier
reiche Baumwollernten eingebracht werden.</p>
<p class="calibre13"><span id="Seite_43" title="[S. 43]"></span></p>
<p class="calibre13">Durch diese Kalksteinplatte arbeitet sich der Euphrat in zahllosen
kleinen Windungen nach Südosten. Wo das Gestein dem Ansturm des
Stromes getrotzt hat, und dieser sich daher auf etwa 100 Meter Breite
zusammendrängt, fallen die Ufer schroff ab; in den oft alabasterweißen
Wänden hat das Wasser in jahrtausendelanger Arbeit schalenförmige
Vertiefungen und gigantische Felsentore, Grotten und Höhlen, Löcher und
Klüfte ausgewaschen, in denen Raubvögel und Dohlen horsten. Hier und da
scheint die Natur mit der Überlegung des Menschengeistes geschaffen zu
haben; steile Treppen mit gewaltigen Stufen führen die Uferwände empor,
oder man glaubt mächtige Kais zu erkennen, die das Wasser eindämmen
sollen. Meist ist die Erosionsterrasse bei konkaven Uferstrecken ein
oder mehrere Meter hoch, senkrecht und sogar überhängend; Wurzelfasern
von Kräutern und Sträuchern reichen ins Wasser herunter, und ab und
zu stürzen Erdklumpen klatschend ab. Man hört und sieht, wie der Fluß
sein Bett unablässig formt, am konkaven Ufer bricht er ab und reißt er
nieder, und die Wellen schäumen um Felsblöcke, die herabgestürzt und an
seichten Stellen liegen geblieben sind; am konvexen Ufer baut er auf,
manche flachen, unfruchtbaren Anschwemmungen können erst gestern oder
vorgestern entstanden sein. Auf diesen Strecken lassen sich nur hier
und da schmale Uferstreifen bewässern und bebauen.</p>
<p class="calibre13">Dann wieder schiebt sich die Kalksteinschale rechts und links mehrere
hundert Meter zurück, so daß der Strom bei Hochwasser eine Breite
bis zu 800 Metern gewinnt und sich wie eine Meeresbucht vor uns
ausdehnt, deren Weite und Richtung kaum erkennbar ist. Die Gipfel
der Höhen schimmern grün, hier und da ist Lava drübergebreitet. Oft
tragen die beherrschenden Höhen auch Ruinen von Festungen und Türmen,
von denen aus die Völker des Altertums wahrscheinlich herannahende
Kriegsgefahr meldeten. Auf dem weiten Uferland weiden Ziegen, Schafe
und Rinder, der Reichtum der Nomaden; Klippen und Landzungen springen
als schaumumwirbelte Wellenbrecher in den Strom vor, auf breiten
Schlammbänken sitzen Möwen und Meerschwalben wie Perlenreihen und
steigen bei unserem Nahen mit gellenden Schreien in die Luft. Oft teilt
sich auch der Strom durch langgestreckte Inseln, die das Hochwasser
jetzt überspült; Sträucher und Steinhütten, die über die Oberfläche<span id="Seite_44" title="[S. 44]"></span>
hervorragen, verraten dem Steuermann der Fähre ihre Nähe. Erst wenn das
Wasser fällt, werden sie wieder zu richtigen Inseln.</p>
<p class="calibre13">Während der ganzen Stromfahrt bietet der Durchbruch des Euphrat durch
diese Kalksteinplatte eine Fülle charakteristischer Formen, und ich
habe das großartigste Naturtheater vor mir, das sich denken läßt; in
wechselnden Szenerien kommt mir die Landschaft entgegen, während ich
selbst in tiefster Ruhe das köstliche Schauspiel genieße. Kletterte
ich die Uferwände hinan, so sähe ich nur eine öde, endlose Steppe; man
braucht sich nur wenige Kilometer vom Euphrat zu entfernen und sieht
keine Spur mehr von der Nähe dieses prächtigen Flußtals.</p>
<p class="calibre13">In den ersten Tagen ging meine Stromfahrt so langsam vor sich, daß ich
schon daran verzweifelte, auf diesem Weg überhaupt Bagdad zu erreichen.
Ein oder zwei, höchstens drei Meter in der Sekunde war bei ruhigem
Wetter die Durchschnittsgeschwindigkeit meiner Fähre; das machte in
der Stunde 4 bis 7 Kilometer, an sich ein ganz erfreuliches Tempo.
Da aber meine Arbeit an Bord Tageslicht erforderte, mußten wir die
ruhigen Nächte über still liegen; außerdem machten uns Nebel und die
Frühlingsboten, Regen und Sturm, so viel zu schaffen, daß wir immer
wieder in den Schutz der steilen Uferwände flüchten und halbe Tage
lang vor Anker gehen mußten. Bei 13 und 14 Grad Luftwärme fror ich im
Schatten meines Sonnendachs. Der Wind pfiff quer durch meine Hütte,
und durch die Dachritzen tropfte der Regen auf Bett und Schreibtisch,
bis ich ein kleines, grünes Zelt darüber nagelte, das ich auf meiner
unglücklichen Autoreise von Major Reith erhalten hatte; mein eigenes
großes, weißes Zelt hatte bei dem übrigen Gepäck in Bir-dava bleiben
müssen. Erst am 17. April machte sich der Frühlingsanfang mit 24 Grad
Wärme bemerkbar. Trotzten wir dem Wind, so trieb die Fähre regellos von
einem Ufer zum andern, drehte sich wie eine Nußschale, so daß Ruderer
und Steuermann machtlos waren, trieb auch wohl auf erst in der Nähe
erkennbare Schlammbänke, und einmal mußten wir sie sogar wieder in ihre
beiden Hälften zerteilen, um nur wieder flott zu werden. Wenig aber
fehlte, und sie hätte mitsamt ihrer Besatzung ein vorschnelles Ende in
den strudelnden Wassern des Euphrat gefunden.</p>
<p class="calibre13">Das war am 18. April, als wir Rakka hinter uns hatten und eine Strecke
weit unterhalb das Dorf Säbcha am Fuße der Kalkwand<span id="Seite_45" title="[S. 45]"></span> in Sicht kam.
Säbcha ist eine Poststation auf dem Wege von Aleppo nach Bagdad.</p>
<p class="calibre13">Der Strom war in den letzten Tagen über einen Meter gestiegen.
Seit einer Weile wehte Ostwind. Die Sonne verschwand hinter
undurchdringlichem Gewölk, und über uns begann der Donner zu grollen
in immer kürzeren Zwischenräumen und immer lauter. Die Luft war
drückend schwül, und alle Anzeichen deuteten daraufhin, daß eine
rasende Entladung bevorstand. Die Arbeiter an den Schöpfwerken blickten
prüfend zum Himmel, spannten die Ochsen aus und trieben sie zu den
Zelten. Schon begann auch der Regen auf das Dach meiner Hütte und das
ölgetränkte grüne Zelt niederzuprasseln.</p>
<p class="calibre13">Es fehlten gerade noch vier Minuten an ½6. Ich hatte eine neue Peilung
genommen, die zeigte, daß wir S 40 W fuhren. Langsam glitten wir am
rechten Ufer hin und streiften eine kleine, grasbewachsene Insel, die
sich bei niedrigem Wasserstand mit dem Festland vereinigen mußte. In
einer Viertelstunde hoffte ich am Han, dem Postwirtshaus, von Säbcha zu
sein.</p>
<p class="calibre13">Da hörte ganz plötzlich der Regen auf. Der Donner verstummte, und
einen Augenblick herrschte unheimliche Stille. Nur einen Augenblick!
Die nun folgenden zwanzig Minuten aber werde ich niemals vergessen.
Sie brachten das fürchterlichste, wildeste Naturschauspiel, das ich
jemals erlebt habe, und ich habe doch ziemlich viel dergleichen
mitgemacht. Erst fielen vereinzelte, schwere Tropfen, dann schmetterte
ein Platzregen herunter, wie ihn nur die Tropen kennen. Gleichzeitig
brauste ein betäubender Orkan über den Strom. Die Fähre stutzte wie vor
Schreck, stand einen Augenblick still, dann drehte sie sich so, daß
die Backbordhälfte mit der Hütte leewärts lag und somit als Windfang
und Segel wirkte. Und sofort trieben wir in reißender Schnelligkeit
quer durch die Strömung zum linken Ufer hin. Der Euphrat mochte hier
etwa vierhundert Meter breit sein, und diese weite Fläche hatte sich
in wenigen Minuten mit gewaltigen, schaumgekrönten Wogen bedeckt,
deren Kämme immer höher emporspritzten und über die Reling der leeren
Luvfähre stürzten. In dieser Hälfte unsres Fahrzeuges stieg das Wasser
beunruhigend an, und ich berechnete schon mit Entsetzen den Augenblick,
da sie untersinken und die andere Hälfte nebst Hütte und allem mit sich
in die Tiefe reißen mußte.</p>
<p class="calibre13"><span id="Seite_46" title="[S. 46]"></span></p>
<p class="calibre13">Der furchtbare Druck des Sturms auf die Hütte trieb außerdem
die Backbordfähre so hart leewärts, daß die Reling ganz auf die
Wasseroberfläche zu liegen kam. Nur noch ein paar Finger breit
tiefer, und wir waren verloren! Es knackte und knallte in dem dünnen
Holzwerk der Hütte, als wollte sie jeden Augenblick bersten und in
die Luft fliegen, und zwischen den Planken der Luvwand spritzte der
sturmgepeitschte Regen in wagerechten Strahlen herein. Ich raffte
Karten, Bücher usw. zusammen aufs Bett und barg sie unter Decke und
Regenmantel. Dann stemmte ich mich mit aller Kraft gegen die Luvwand,
um ihren Widerstand gegen den Wind zu verstärken. Ein heftiger Knall
— das Zelttuch draußen ist losgerissen! Eben flattert ein Zipfel am
Fenster vorüber; ich greife zu und habe ihn fest. Naß bis auf die Haut
halte ich nun das wie ein Notsignal hin und her klatschende Zelt,
stemme dabei die Schultern immerfort gegen die Wand, obgleich ich unter
dem Luftdruck kaum atmen kann, und jage so mit der Fähre in rasendem
Tempo — ja, wohin? Keine Möglichkeit einer Orientierung! Durchs
Fenster sah ich nur in ein graues Chaos von Wogen und Schaumkämmen,
die mit erbitterter Wut gegen die Hütte hämmerten und die Luvfähre mit
Wasser zu füllen drohten. Ob wir wohl noch ein Ufer erreichten, ehe die
Fähre bis zum Rande voll war und sank oder von den Wogen zerschmettert
wurde? Trieben wir parallel mit der Hauptrichtung des Stromes, dann
mußte sie untergehen, ehe wir an Land waren. Der Sturm war aus Südwest
gekommen, und in derselben Richtung strömte dieser Teil des Flusses.
Später zeigte sich glücklicherweise, daß die Gleitkraft der Wassermasse
eine Ablenkung hervorrief, wodurch unsere Richtung genau östlich wurde.</p>
<p class="calibre13">Betäubendes Donnern und Tosen ringsum; der Regen geht in Hagel über,
Eisklumpen knallen gegen die dünne Wand der Hütte, als würden wir
von einer Menschenmenge mit Steinwürfen bombardiert. Die Hagelkörner
zischen ins Wasser wie Flintenkugeln und ballen sich auf der Fähre zu
kleinen weißen Inseln zusammen; einige, die ich später maß, hatten
einen Durchmesser von achtzehn bis zwanzig Millimeter. Der Aufenthalt
im Freien mußte lebensgefährlich sein. Meine Leute waren schon bei den
ersten Vorboten des Sturms unter Deck gekrochen; ging die Fähre unter,
so mußten alle vier Mann wie in einer Mausefalle ertrinken.</p>
<div class="figcenter10" id="p047_ill">
<img alt="" class="w1" id="id-4606661147723574303" src="Images/img0014.jpg"/>
<div class="caption1">Araber mit seiner jungen Frau.
  <div class="linkedimage"><span id="p047_ill_gross">⇒<br class="calibre8"/>
<span class="s1">GRÖSSERES BILD</span></span></div>
</div>
</div>
<p class="calibre13"><span id="Seite_48" title="[S. 48]"></span></p>
<p class="calibre13">Endlich trat etwas Dunkles aus dem Nebel hervor: Tamariskenbüsche
am linken Ufer. Wir waren also quer über den Euphrat gejagt, nicht
aufwärts gegen den Strom. Eben kroch mein Kapitän Mohammed aus seinem
Versteck hervor und brachte durch sein Schreien auch die anderen auf
die Beine. Es war auch die höchste Zeit! In wenigen Sekunden mußten wir
an Land geschleudert werden — das Vorderteil der Fähre zerriß schon
die Wurzeln der Tamarisken, die wie Vorhänge von der zwei Meter hohen,
senkrechten Erosionsterrasse herabhingen und das Dach der Hütte fegten.
Mahmud schwang sich an einer Tamariske aufs Ufer hinauf, Kerit folgte
ihm, rutschte aber aus und bis an die Schultern ins Wasser hinein. Im
selben Moment prallte die Fähre heftig auf, der Stoß wurde aber von
dem Wurzelwerk aufgefangen. Schon war auch Hussein an Land und schlang
ein Seil um einen festen Ast. Die Fähre schaukelte und schlingerte,
riß sich aber nicht mehr los. Schnell war das Zelt gerettet und
zusammengepackt.</p>
<p class="calibre13">Nun ließ die Heftigkeit des Sturmes bald nach. Regen und Hagel hörten
ebenso plötzlich auf, wie sie gekommen waren. Das Zentrum des Unwetters
zog in nordwestlicher Richtung weiter. Es war dreizehn Minuten vor
6; die ganze Geschichte hatte nur zwanzig Minuten gedauert. Das
Thermometer zeigte 22 Grad. Die Erde war noch weiß von Hagelkörnern,
die jedoch bald wegschmolzen.</p>
<p class="calibre13">Es dauerte eine Weile, bis wir uns von dem Schreck erholt hatten.
Nach und nach wurde die Luft ganz ruhig, glättete sich die eben noch
so aufgeregte Wasserfläche, und man hörte nur das stille Brausen der
ersterbenden Wogen. Mahmud begab sich nach dem nächsten Nomadenzelt, um
Holz, Brot und Joghurt zu holen. Die anderen sammelten Tamariskenzweige
und machten mit vieler Mühe ein Feuer an; dann entkleideten sie
sich und trockneten ihre Sachen. Auch in meiner Hütte war alles
so durchnäßt, daß Bettzeug und Decken an Stangen ums Feuer zum
Trocknen aufgehängt werden mußten. Schließlich schöpften meine Leute
das Wasser aus der Steuerbordfähre. Welch ein Glück, daß ich zwei
zusammengebundene Schahtur hatte! Einer allein mit freier Hütte wäre
ohne Zweifel gekentert. Die leere Steuerbordfähre hatte meinem Fahrzeug
die nötige Festigkeit gegeben, um einen solchen Sturm auszuhalten.</p>
<p class="calibre13"><span id="Seite_49" title="[S. 49]"></span></p>
<p class="calibre13">Es dunkelte. Am nordöstlichen Himmel flammten unter einer
pechschwarzen, am Hinterrand scharf begrenzten Wolkenbank blaue Blitze
und erhellten den Strom und die Tamarisken am Ufer, daß sie wie
friedlose Geister mit bittend ausgestreckten Armen erschienen. Nach dem
Lärm, der eben noch unsere Ohren erfüllt hatte, lag mir die friedvolle
Stille der Nacht geradezu beklemmend auf der Brust. Ich atmete auf, als
endlich die Schakale ihr übliches Abendlied anstimmten, das auf dem
einen Ufer mit langgezogenem Geheul begann, gleichsam im Bogen auf das
andere übersprang und bald wie Hohngelächter, bald wie der Hilferuf
bangender Kinder klang, und dazwischen der traurige Schrei eines Esels
vom anderen Ufer herübertönte.</p>
<p class="calibre13">Diese zyklonartigen Stürme, die von Zeit zu Zeit über Mesopotamien
hinziehen, sind der Schiffahrt auf dem Euphrat äußerst gefährlich, und
wenn ich weiterhin an wracken Booten vorüberkam, begriff ich nur zu
gut, wie solche Schiffbrüche vor sich gegangen waren. Noch vor einigen
Wochen wurde Kapitän Pfeffer, einer meiner Bekannten aus Dscherablus,
als er mit seiner Flottille von großen, mit Munition und Gewehren
beladenen Fähren bei Rakka vor Anker lag, von einem Zyklon überrascht.
Der Sturm kam ohne jedes warnende Vorzeichen wie ein Dieb in der Nacht,
meterhohe Wellen füllten die Fahrzeuge mit Wasser, und drei davon
sanken; ein Deutscher, ein Photograph aus Metz, ertrank dabei. Ein
ähnliches Schicksal konnte auch der Fliegerabteilung, die zwei Tage vor
mir Rakka verlassen hatte, oder der bayrischen Batterie des Majors von
Schrenk, die ungefähr am 15. April von Dscherablus hatte aufbrechen
sollen, beschieden sein. Wie ich aber später hörte, erreichte sie der
Sturm, der meine Fähre fast zum Kentern gebracht hatte, nicht; sein
Zentrum war also ganz scharf begrenzt gewesen.</p>
<div class="figcenter4" id="p050_ill">
<img alt="" class="w1" id="id-1150747010853179527" src="Images/img0015.jpg"/>
<div class="caption1">Chesney’s Fähre auf dem Euphrat.<br class="calibre8"/>
<span class="s1">(Aus: „<span class="antiqua">Narrative of the Euphrates
  Expedition</span>“.</span>)
  <div class="linkedimage"><span id="p050_ill_gross">⇒<br class="calibre8"/>
<span class="s1">GRÖSSERES BILD</span></span></div>
</div>
</div>
<p class="calibre13">Auch aus älterer Zeit finde ich solch ein Ereignis beschrieben, das
mit meinem Erlebnis die größte Ähnlichkeit hat. In den Jahren 1835/37
untersuchte Oberst Francis Rawdon Chesney im Auftrag der englischen
Regierung die Schiffahrtsverhältnisse auf dem Euphrat und Tigris. Am
21. Mai 1836, mittags ½2 Uhr, wurde seine Expedition von einem Zyklon
überfallen, der ebenso plötzlich daherbrauste, wie der von mir erlebte,
ebenso mit plötzlicher Finsternis einsetzte, nur fünfundzwanzig
Minuten dauerte und einen der beiden Dampfer Chesneys, den „Tigris“,
versenkte, wobei vier Offiziere, elf Artilleristen und Matrosen<span id="Seite_51" title="[S. 51]"></span> und
fünf Eingeborene ums Leben kamen. Der Sturm preßte den Dampfer so stark
nieder, daß die offenen Kajütenfenster unter Wasser gerieten. Schon war
der Befehl gegeben: Rette sich wer kann! als sich für einen Augenblick
die Dunkelheit erhellte und das Ufer ganz nahe schien. Sofort hieß es
wieder: Jeder auf seinen Posten! Aber im nächsten Augenblick herrschte
wieder schwarze Nacht, und eine Minute später war das Schiff gesunken.
Ebenso schnell wie er kam, war der Zyklon wieder vorüber, und seine
Spur war ebenso schmal gewesen, wie ich es beobachtet hatte. Chesney,
der sich mit zwanzig Mann von dem sinkenden Schiffe hatte retten
können, will Hagelkörner von anderthalb Zoll Dicke gemessen haben; das
erscheint mir etwas übertrieben, und seine Meinung, solche Zyklone über
dem Euphrat seien „äußerst selten“, widerlegt sich wohl durch meine
Erfahrungen.</p>
<p class="calibre13">Chesneys Schilderungen liest man noch heute mit größtem Interesse.
Daß damals an den Ufern des Euphrat noch Löwen vorkamen, hört man mit
einigem Erstaunen; im übrigen ist noch alles so, wie er es beschrieb;
man erkennt die Orte Der-es-Sor, Ana und Hit deutlich wieder,
sogar den Hügel von Babel, wo damals noch keinerlei Ausgrabungen
begonnen waren, und die Karte des Euphrat, die sich in seinem Werk
„<span class="antiqua">Expedition for the survey of the rivers Euphrates and Tigris in
the years 1835–1837</span>“ (London, 1850–68) findet, ist so gewissenhaft
ausgeführt, daß sie noch während dieses Weltkrieges benutzbar
war; man brauchte nur in die vergrößerte Kopie die Änderungen des
Stromlaufs während der letzten achtzig Jahre einzuzeichnen. Die von ihm
angegebenen Namen der Berge, Hügel, Ruinen, Landzungen usw. stimmten
alle, nur die Ortsnamen waren andere; denn man nennt die Orte am Ufer
nach dem Scheich des Stammes, der dort zeltet. Die Namen wechseln daher
alle Menschenalter.</p>
<p class="calibre13">Chesneys Expedition hatte die Aufgabe, die Möglichkeit einer
schnelleren Überlandverbindung mit Indien zu untersuchen. Der Euphrat
wurde bis Meskene schiffbar gefunden, für nicht zu tief gehende Dampfer
sogar bis Biredschik; bis zum Golf von Alexandrette wäre dann nur noch
eine kurze Strecke zu überwinden gewesen. Chesney versichert, die
Araber an den Ufern des Euphrat und ebenso die türkische Regierung
hätten die geplante Eröffnung eines neuen Handelsweges zwischen Indien
und Europa freudig begrüßt. Aber ein Menschenalter blieb das Projekt
unausgeführt, und dann machte der Bau des Suezkanals die Euphratstraße
für England überflüssig.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?0228c9da